import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Main from './screens/Main';
import Feedback from './screens/Feedback';
import Login from './screens/Login';
import { appName } from './utils/constants';
import EnrolleeFeedback from './screens/EnrolleeFeedback';
import { scale } from 'react-native-size-matters';

export type AppStackParamList = {
	Main: undefined;
	EnrolleeFeedback: undefined;
	Feedback: undefined;
	Login: undefined;
};

const Stack = createStackNavigator<AppStackParamList>();

export default function AppStack(): JSX.Element {
	return (
		<Stack.Navigator>
			<Stack.Screen
				name="Main"
				component={Main}
				options={{
					title: appName,
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
				}}
			/>
			<Stack.Screen
				name="EnrolleeFeedback"
				component={EnrolleeFeedback}
				options={{
					title: `${appName} - Enrollee Feedback`,
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
				}}
			/>
			<Stack.Screen
				name="Feedback"
				component={Feedback}
				options={{
					title: `${appName} - Feedback`,
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
				}}
			/>
			<Stack.Screen
				name="Login"
				component={Login}
				options={{
					title: `${appName} - Login`,
					headerStyle: { elevation: 0 },
					headerTitleStyle: { fontSize: scale(16) },
				}}
			/>
		</Stack.Navigator>
	);
}
